// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {
  BootstrapVue,
  BIcon,
  BIconArchive,
  BIconPeople,
  BIconBuilding,
  BIconBook,
  BIconPower,
  BIconPlus,
  BIconPencil,
  BIconArrowLeft,
  BIconTrashFill,
  BIconEnvelope,
  BIconStopwatch

} from 'bootstrap-vue'

import App from './App'
import Axios from 'axios'
import router from '@/router/router'
import store from '@/store/store'

//TODO: BootstrapVue icons will be trimmed down to only the needed buttons, once we know
//All the buttons we need.
Vue.use(BootstrapVue)

//Add Icons for dashboard:
// Vue.use(BootstrapVueIcons)
Vue.component('BIcon', BIcon)
Vue.component('BIconArchive', BIconArchive)
Vue.component('BIconPeople', BIconPeople)
Vue.component('BIconBuilding', BIconBuilding)
Vue.component('BIconBook', BIconBook)
Vue.component('BIconPower', BIconPower)
Vue.component('BIconPlus', BIconPlus)
Vue.component('BIconPencil', BIconPencil)
Vue.component('BIconArrowLeft', BIconArrowLeft)
Vue.component('BIconTrashFill', BIconTrashFill)
Vue.component('BIconEnvelope', BIconEnvelope)
Vue.component('BIconStopwatch', BIconStopwatch)


// Bootsrap css import:
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue'

// devextreme imports:
import 'devextreme/dist/css/dx.light.css'
import 'devextreme/dist/css/dx.common.css'


//custom Bootstrap:
import '@/assets/css/custom.css'

//** To help limit the build size, limit devextreme components to a need basis **/
import { DxDataGrid, DxMasterDetail } from "devextreme-vue/data-grid"
import DxLoadPanel from "devextreme-vue/load-panel"
import DxForm from "devextreme-vue/form"
import DxButton from "devextreme-vue/button"
import DxActionSheet from "devextreme-vue/action-sheet"
import DxPopup from "devextreme-vue/popup"
import DxDateBox from 'devextreme-vue/date-box'
import DxCalendar from 'devextreme-vue/calendar'

Vue.component('DxDataGrid', DxDataGrid)
Vue.component('DxMasterDetail', DxMasterDetail)
Vue.component('DxLoadPanel', DxLoadPanel)
Vue.component('DxForm', DxForm)
Vue.component('DxButton', DxButton)
Vue.component('DxActionSheet', DxActionSheet)
Vue.component('DxPopup', DxPopup)
Vue.component('DxDateBox', DxDateBox)
Vue.component('DxCalendar', DxCalendar)

// import './assets/bluedge-css/dx.generic.bluedge-theme.css'

Vue.config.productionTip = false

// Vue.prototype.$http = Axios.create({
//   withCredentials: true,
//   baseURL: 'https://localhost:5001/api/'
// })

// Axios.defaults.headers.common['Authorization'] = token


Axios.defaults.baseURL = 'http://localhost:5050'
// Axios.defaults.baseURL = '/'
Axios.defaults.withCredentials = true
Axios.defaults.crossDomain = true
// Vue.prototype.$http = Axios


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js